import yupLocales from '@/assets/yupLocales';
import { makeRequired, makeValidateSync } from 'mui-rff';
import { useMemo } from 'react';
import { setLocale } from 'yup';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation.tsx';

// returns the validate and required functions for the form that is used by react-final-form and mui-rff
// it also sets the yup locale to the current i18n language
export default function useFormSchema(yupSchema) {
  const { i18n } = useInlineTranslation();
  const lang = i18n.resolvedLanguage;

  const { validate, required } = useMemo(() => {
    if (yupLocales) setLocale(yupLocales[lang]);
    const validate = makeValidateSync(yupSchema);
    const required = makeRequired(yupSchema);
    return { validate, required };
  }, [lang, yupSchema, yupLocales]);

  return { validate, required };
}
